import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';
import {
  LoanQuoteRequest,
  LoanQuoteRequirement,
  LoanQuoteRequirementRequest,
} from '@axo/shared/data-access/types/loan_quote';

export function requirementLoanQuote({
  url: { service: baseURL },
  token,
}: IAPI) {
  return async ({
    loanQuoteID,
  }: LoanQuoteRequest): Promise<Array<LoanQuoteRequirement>> =>
    send({
      baseURL,
      token,
      path: `/loan-quote/${loanQuoteID}/requirement`,
      method: 'GET',
    });
}

export function patchLoanQuoteRequirements({
  url: { service: baseURL },
  token,
}: IAPI) {
  return async ({
    loanQuoteID,
    requirementID,
    status,
  }: LoanQuoteRequirementRequest): Promise<LoanQuoteRequirement> =>
    send({
      baseURL,
      token,
      path: `/loan-quote/${loanQuoteID}/requirement/${requirementID}/${status}`,
      method: 'PATCH',
    });
}
